module.exports = __webpack_public_path__ + "assets/bloqhouse.5e977552.svg";